"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callParamsSchema = void 0;
const zod_1 = require("zod");
exports.callParamsSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    interviewId: zod_1.z.string(),
    simulationScriptId: zod_1.z.string().optional(),
});
